module.exports = __webpack_public_path__ + "static/ui-workspace-1b6a15348093015fada4bc93aa4aecc5.png";